import * as S from './AgentsModal.styles';
import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { formatTableData, TABLE_HEADERS } from './AgentsModal.config';
import { Table } from 'components';
import { faComment } from '@fortawesome/free-solid-svg-icons';
import { ROLES, STATUS } from 'configs/constants';
import { internalChat } from 'socket/socket';
import { showModal, hideModal } from 'redux_toolkit/reducers/modals/modalsSlice';


export const AgentsModal = () => {
  const dispatch = useDispatch();
  const {partnerAgents, partnerTeamleads} = useSelector(({ agents }) => agents);
  const currentUser = useSelector(({ userPartner }) => userPartner.userData);

  const teammates = partnerTeamleads.concat(partnerAgents);
  const filtredTeamList = useMemo(() => {
    return teammates.filter(agent => agent.status !== STATUS.OFFLINE &&  agent.status !== STATUS.INACTIVE && currentUser._id !== agent._id);
  }, [teammates, currentUser])

  const canStartInternalChat = (targetUser) => {
    if (currentUser.role === ROLES.ADMIN) return false;
    if (currentUser.role === ROLES.TEAMLEADER) return true;
    if (currentUser.role === ROLES.AGENT && targetUser.role === ROLES.TEAMLEADER) return true;
    return false;
  };

  const getTableActions = (agent) => (
    <S.ActionButton
      onClick={() => {
        if (!canStartInternalChat(agent)) return;
        internalChat(agent._id);
        dispatch(showModal({type: 'internal', agent, isNewChat: true }))}
      }
      disabled={!canStartInternalChat(agent)}
    >
      <FontAwesomeIcon icon={faComment} style={{
        width: 15,
        height: 15,
        color: !canStartInternalChat(agent) ? 'grey' : 'rgb(15, 61, 86)'
      }}/>
    </S.ActionButton>
  )

  return (
    <S.AgentsModalContainer>
      <Table
        hideModal={hideModal}
        cardHeaderText='Agents'
        tableHead={TABLE_HEADERS[currentUser.role]}
        tableData={formatTableData(filtredTeamList, getTableActions, currentUser)}
        notFound={filtredTeamList.length > 0? '' : 'Not Connections'}
      />
    </S.AgentsModalContainer>
  )
}